import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 bg-dark text-white/70 text-center" data-id="element-66">
      <div className="max-w-4xl mx-auto space-y-2" data-id="element-67">
        <p className="text-sm" data-id="element-68">© 2026 Todos los derechos reservados.</p>
        <p className="text-sm" data-id="element-69">
          Este producto es digital. El acceso se entrega luego de completar la
          compra.
        </p>
      </div>
    </footer>;
}